import http from "./http";

class TarificationsService {
    index(token){
        return http.get("/api/tarifications")
    }

    index_tarifications(){
        return http.get("/api/frontend/tarifications")
    }

    store(data){
        return http.post("/api/tarifications/store", data)
    }

    edit(id,token){
        return http.get(`/api/tarifications/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return http.get(`/api/tarifications/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data,token){
        return http.post(`/api/tarifications/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return http.delete(`/api/tarifications/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new TarificationsService()